// extracted by extract-css-chunks-webpack-plugin
module.exports = {"bg":"app-components-staticpages-blocks-frontpage-separator--bg"};